import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8 2.667c.368 0 .667.298.667.666v4h4c.334 0 .611.247.66.568l.006.099c0 .368-.298.667-.666.667h-4v4c0 .334-.247.611-.568.66L8 13.332c-.368 0-.667-.298-.667-.666v-4h-4c-.334 0-.611-.247-.66-.568L2.668 8c0-.368.298-.667.666-.667h4v-4c0-.334.247-.611.568-.66z",
			transform: "translate(-960 -382) translate(960 382)"
		})
	})
});
export default SvgPlus;
